import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  buildLovemoCanonical,
  getLovemoSocialImage,
  resolveLovemoSeo,
} from "@/seo/lovemoSeo";

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function LovemoSeoManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = resolveLovemoSeo(pathname);
    const canonical = buildLovemoCanonical(pathname);

    document.title = seo.title;

    upsertMeta("name", "description", seo.description);
    upsertMeta("name", "keywords", seo.keywords);
    upsertMeta("name", "robots", seo.noindex ? "noindex,follow" : "index,follow");

    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", "Lovemo");
    upsertMeta("property", "og:title", seo.ogTitle);
    upsertMeta("property", "og:description", seo.ogDescription);
    upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:image", getLovemoSocialImage());

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", seo.twitterTitle);
    upsertMeta("name", "twitter:description", seo.twitterDescription);
    upsertMeta("name", "twitter:image", getLovemoSocialImage());

    upsertCanonical(canonical);
  }, [pathname]);

  return null;
}